import { push } from 'react-router-redux';

import { SHOW_APPROVE, CHANGE_STEP } from '../constants';
import { STEP1, START_STEP } from '../../constants/steps';
import {
  sendStats,
  CLICK_APPLY_BUTTON,
  CLICK_BUTTON_SUBMIT_APPEAL
} from '../../resources/metrics';
import { saveDraft } from '../draft/actions';

export function showApproveModal(close = false) {
  if (!close) {
    sendStats(CLICK_BUTTON_SUBMIT_APPEAL());
  }

  return dispatch => {
    dispatch({ type: SHOW_APPROVE, payload: close });
    dispatch(saveDraft());
  };
}

export function goToFirstStep(isFirstRequest) {
  sendStats(CLICK_APPLY_BUTTON());
  return dispatch => {
    dispatch({
      type: CHANGE_STEP,
      payload: isFirstRequest ? START_STEP : STEP1
    });
    dispatch(push('/new/'));
  };
}

export function goToHomePage() {
  return dispatch => {
    dispatch({ type: CHANGE_STEP, payload: START_STEP });
    dispatch(push('/'));
  };
}
